var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9471 11.0122L0.00138891 9.68722L0 1.31184C0.000181815 1.08818 0.0652942 0.868276 0.18916 0.672979C0.313026 0.477682 0.491538 0.313472 0.707762 0.195926C0.923986 0.0783804 1.17075 0.0113972 1.42465 0.00133059C1.67855 -0.00873599 1.93116 0.0384479 2.15852 0.138406L24.1771 9.82657C24.4244 9.93575 24.6324 10.1033 24.7777 10.3105C24.923 10.5178 25 10.7565 25 11C25 11.2435 24.923 11.4822 24.7777 11.6895C24.6324 11.8967 24.4244 12.0643 24.1771 12.1734L2.1613 21.8616C1.93394 21.9615 1.68132 22.0087 1.42743 21.9987C1.17353 21.9886 0.926764 21.9216 0.71054 21.8041C0.494316 21.6865 0.315804 21.5223 0.191938 21.327C0.068072 21.1317 0.00295996 20.9118 0.00277814 20.6882V12.3128L14.9485 11.0122H14.9471Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.eba708a449da0f46fca26538918181da.svg";
export { ForwardRef as ReactComponent };